import { Trans } from 'react-i18next';

import { BreadcrumbLink, ProductSelectionPaths, type RouteObjectWithBreadcrumbs } from '@/shared/lib/react-router';

export const CheckoutPageRoute: RouteObjectWithBreadcrumbs = {
  // Пустой путь (не index), чтобы страница чекаута могла нести свой breadcrumb «Подтверждение заказа».
  path: '',

  handle: {
    breadcrumb: {
      element: (
        <BreadcrumbLink to={ProductSelectionPaths.CHECKOUT_PATH}>
          <Trans i18nKey="breadcrumb" ns="checkout-page" />
        </BreadcrumbLink>
      ),
    },
  },

  lazy: async () => {
    const { CheckoutPage } = await import(
      /* webpackChunkName: "CheckoutPage" */
      './CheckoutPage.async'
    );

    return {
      Component: () => <CheckoutPage />,
    };
  },
};
